import styled from "styled-components";

const buttonConfig = {
	primary: {
		background: "#7E2F8A",
		boder: "none",
		color: "#fff",
	},
	backgroundless: {
		background: "transparent",
		boder: "1px solid #D9D9D9",
	},
	disabled: {
		background: "#D9D9D9",
		boder: "none",
		color: "#fff",
	},
	cancelReservation: {
		background: "transparent",
		boder: "none",
		color: "#A157B0",
	},
	genericModalPrimary: {
		background: "#FF4D4F",
		boder: "none",
		color: "#fff",
		width: "100%",
	},
	backgroundWhite: {
		background: "#fff",
		boder: "none",
		color: "#000 !important",
		width: "100%",
	},
};

export const Wrapper = styled.button`
	font-family: "Montserrat", sans-serif;
	padding: 8px;
	background: ${(props) => {
		return props.disabled
			? buttonConfig["disabled"].background
			: buttonConfig[props.typeForStyled].background;
	}};
	border: ${(props) =>
		props.disabled
			? buttonConfig["disabled"].boder
			: buttonConfig[props.typeForStyled].boder};
	color: ${(props) =>
		props.disabled
			? buttonConfig["disabled"].color
			: buttonConfig[props.typeForStyled].color};
	border-radius: 4px;
	min-width: 100px;
	font-weight: 500;
	margin-right: 12px;
	max-height: 38px;
	width: ${(props) => props.size && props.size};
	:hover,
	:active {
		cursor: pointer;
	}
`;
